var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", [
      _c("div", {
        staticClass: "transaction__type",
        class: _vm.getPaymentClass,
      }),
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.transaction.id))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.getTransactionName))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.transaction.date))]),
    _vm._v(" "),
    _c("td", [
      _c("strong", {
        staticClass: "color__red",
        class: _vm.getAmountClass,
        domProps: { innerHTML: _vm._s(_vm.getPrice) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }